<template>
   <div     class="">
       <div>
           <h2>Device Profile Templates</h2>
       </div>

        <device-profile-template-show
                v-model:show="showDeviceProfileTemplate"
                :device-profile="selectedProfileTemplate"
                :can-toggle-active="true"
        ></device-profile-template-show>

        <!-- Table -->
        <ajax-table     :data="data"
                        :headers="headers"
                        v-model:loading="ajaxTable.loading"
                        v-model:search="ajaxTable.search"
                        v-model:sort-by="ajaxTable.sortBy"
                        v-model:sort-desc="ajaxTable.sortDesc"
                        v-model:page="ajaxTable.page"
                        v-model:items-per-page="ajaxTable.itemsPerPage"
                        v-model:page-info="ajaxTable.pageInfo"
                        :exportable="false"
                        @loadData="getData"
                        @rowSelected="showProfileModal"
        >
            <!-- Create Device Profile Template Button Right of Search -->
            <template   #search-right>
                <div    v-if="permissions.can('create_device_profile_template')"
                        class="self-start flex items-center w-full md:w-auto ml:0 md:ml-2">
                    <green-button   :href="company.buildCompanyRoute('device-profile-template/create')"
                    >
                        <div    class="inline-flex">
                            <span   class="lnr icon-plus-circle mr-2"></span>
                            <span>Create Device Profile Template</span>
                        </div>
                    </green-button>
                </div>
            </template>

            <!-- Company & Active Indicator -->
            <template   #col-1="props">
                <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                        {{ props.row.company.name }}
                    </span>
                    <span   v-if="permissions.isPartner()"
                            class="my-1 text-gray-500">
                        {{ props.row.company.id }}
                    </span>
                </div>
            </template>

            <!-- Profile Title -->
            <template   #col-2="props">
                <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                        {{ props.row.title }}
                    </span>
                    <span   class="my-1 text-gray-500">
                        {{ props.row.description }}
                    </span>
                </div>

            </template>

            <!-- User who created the profile -->
            <template   #col-3="props">
                {{ props.row.user.display_name }} ({{ props.row.user.email }})
            </template>

            <!-- Creation Date -->
            <template   #col-4="props">
                {{ props.row.created_at }}
            </template>

            <!-- Profile is Active -->
            <template   #col-5="props">
                <div    class="flex items-center">
                    <small-colored-check    :togglable="false"
                                            v-model="props.row.active"
                    ></small-colored-check>

                    <span   class="ml-4 text-gray-600">{{ props.row.targetDeviceType}}</span>
                </div>
            </template>
        </ajax-table>
    </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Pagination from "@/components/Pagination"
import ItemsPerPageSelect from "@/components/ItemsPerPageSelect"
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from '@/components/elements/select2'
import GreenButton from "@/components/elements/green-button";
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import Loading from "@/components/elements/loading";
import DeviceProfileTemplateShow from "@/components/DeviceProfileTemplate/DeviceProfileTemplateShow";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import _isNil from "lodash";

export default {
    name: "DeviceProfileTemplateIndex",
    mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin, UrlParamsMixin],
    components: {
        SmallColoredCheck,
        DeviceProfileTemplateShow,
        Loading, AjaxTable, GreenButton, Pagination, ItemsPerPageSelect, FloatingInput, Select2},
    props: {

    },
    data() {
        return {
            data: [],
            headers: [
                {
                    name: 'Company',
                    sortBy: 'company',
                    show: 'sm',
                },
                {
                    name: 'Title',
                    sortBy: 'title',
                    show: 'sm',
                },
                {
                    name: 'User',
                    sortBy: 'user',
                    show: 'md',
                },
                {
                    name: 'Created On',
                    sortBy: 'created-at',
                    show: 'md',
                },
                {
                    name: 'Active',
                    sortBy: '',
                    show: 'sm',
                },
            ],
            requestNumber: 0,

            // For Modal
            showDeviceProfileTemplate: false,
            selectedProfileTemplate: null,
            preLoadTemplate: null,
        }
    },
    created() {
        this.ajaxTable.sortBy = 'created-at'
        this.ajaxTable.sortDesc = true
    },
    mounted() {
        this.preLoadTemplate = this.urlParamsGet('profileTemplate')
    },
    methods: {
        getData() {
            this.ajaxTable.loading = true
            this.requestNumber++
            let params = JSON.parse(JSON.stringify(this.ajaxTable))
            params.requestNumber = this.requestNumber
            if (!_.isNil(this.preLoadTemplate)) {
                params.profileTemplate = this.preLoadTemplate
            }
            axios.get(this.company.buildCompanyApiInternalRoute('internal-device-profile-template'),
                {
                    params: params,
                }
            ).then(response => {
                let data = response.data
                if (_.isNil(data.meta) || data.meta.requestNumber !== `${this.requestNumber}`) {
                    return
                }

                this.ajaxUpdateTableData(data)

                this.data = !_.isNil(data.data) ? data.data : []
                if (!_.isNil(data.meta.profileTemplate)) {
                    this.selectedProfileTemplate = data.meta.profileTemplate
                    this.showDeviceProfileTemplate = true
                    this.preLoadTemplate = null
                }
                else {
                    this.urlParamsRemove('profileTemplate')
                }
            }).catch(error => {
                console.log(error)
            }).then(() => {
                this.ajaxTable.loading = false
            })
        },
        showProfileModal(rowIndex) {
            this.selectedProfileTemplate = this.data[rowIndex]
            this.showDeviceProfileTemplate = true
            this.urlParamsStore('profileTemplate', this.data[rowIndex].id)
        }
    },
    computed: {

    },
    watch: {
        showDeviceProfileTemplate(val) {
            if (!val) {
                this.urlParamsRemove('profileTemplate')
            }
        }
    },
}
</script>

<style scoped>

</style>